import { NgModule } from '@angular/core'
import { MbWishlistStoreModule } from './store'
import { MbWishlistConnector } from './connectors'

@NgModule({
  imports: [
    MbWishlistStoreModule,

  ],
  providers: [
    MbWishlistConnector
  ]
})

export class MiltenyiWishlistModule {
}
